export const Periods = Object.freeze({
  UPCOMING: 'upcoming',
  PAST: 'past',
  FIXED: 'fixed',
  THIS_WEEK: 'this_week',
  LAST_WEEK: 'last_week',
  THIS_MONTH: 'this_month',
  THIS_YEAR: 'this_year',
  TODAY: 'today',
  ALL_TIME: 'all_time'
})

/** Chip ids for the meetings page date presets (sa_default_preset_toggle). */
export const MEETINGS_PRESET_IDS = Object.freeze({
  UPCOMING: Periods.UPCOMING,
  TODAY: Periods.TODAY,
  THIS_WEEK: Periods.THIS_WEEK,
  LAST_WEEK: Periods.LAST_WEEK,
})

/**
 * URL marker used by the "Upcoming" preset (sa_default_preset_toggle). When present and set to
 * `UPCOMING_PRESET_OFF`, the preset is explicitly untoggled even on an otherwise-default view.
 * Lives here (not in the feature hook) so lightweight modules like `useHomeTabs` can reference it
 * without pulling in the preset hook's dependency graph.
 */
export const UPCOMING_PRESET_PARAM = 'upcoming_preset'
export const UPCOMING_PRESET_OFF = '0'

/**
 * Active preset chip (today / upcoming / this_week / last_week) while `period` stays `upcoming`
 * so the filter UI does not show a date-range filter selection. Default when missing is today.
 */
export const MEETINGS_PRESET_PARAM = 'meetings_preset'

/**
 * URL marker for the meetings-page date selector (sa_default_preset_toggle). Holds a `YYYY-MM-DD`
 * date the user picked from the calendar popover. When present, the untoggled meetings feed
 * re-centers on this date (past + future around it) instead of today. Any preset toggle replaces
 * the whole query string, so this is dropped automatically — which is the "reset to today" behavior.
 */
export const MEETINGS_VIEW_DATE_PARAM = 'view_date'

export const FilterTypes = Object.freeze({
  TEAMS: 'teamsSelect',
  USERS: 'usersSelect',
  STATUS: 'status',
  SCHEDULING_METHOD: 'schedulingMethod',
  ROLE: 'role',
  TRACKING_SELECT: 'trackingSelect',
  BUFFER_VIEW: 'bufferView',
  NOTETAKER_RECAP: 'notetakerRecap'
})

export const allValue = 'all'

// Participants
export const myMeetingsValue = 'my_meetings'

export const permissionValue = 'permission'

export const nonHostValue = 'non_host'


// Status
export const activeValue = 'active'

export const Statuses = {
  ALL: 'all',
  ACTIVE: 'active',
  CANCELED: 'canceled',
  NO_SHOW: 'no_show',
  RESCHEDULED: 'rescheduled',
}

export const FILTER_SCOPE_TYPES = {
  user: ['users', 'teams', 'team', 'all_users_and_teams', 'user_group'],
  team: ['user', 'teams', 'all_users_and_teams']
}

export {
  AllSchedulingMethods,
  buildSchedulingMethodProps,
  normalizePersistedSchedulingMethods,
  SchedulingMethods
} from 'services/search_api/constants'

export const MATCH_MEETING = 'name'
export const MATCH_ATTENDEE = 'attendees'
export const MATCH_TRANSCRIPT = 'transcript'

export const MeetingRoles = {
  HOST: 'HOST',
  COHOST: 'COHOST',
  ATTENDEE: 'ATTENDEE',
  PERMISSION: 'PERMISSION'
}

export const ANALYTICS_MAP = {
  period: 'date_range',
  dateRange: 'date_range',
  inviteeEmails: 'invitee_email',
  eventTypeIds: 'event_type',
  teamIds: 'team',
  userIds: 'user',
  statusIds: 'meeting_status',
  status: 'meeting_status',
  schedulingMethods: 'scheduling_method',
  schedulingMethod: 'scheduling_method',
  role: 'role',
  meetingIntelligenceStatus: 'notetaker_recap'
}

export const allowedScopeTypes = [
  'my_calendly',
  'page_single',
  'user_group',
  'user_single'
]
